import React from "react";
import Re100MarketRec from "../../rp/implWayAnalysis/Re100MarketRec"
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

export default function RecPrcInfo(props: Readonly<DashboardModuleProps>) {

  return (
    <DashboardCard
      title="REC 시세정보"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/rp/impleWayAnalysis"
      dashboardConfig={props.dashboardConfig}
    >
      <Re100MarketRec height={615}/>
    </DashboardCard>
  );
}
